export default __webpack_public_path__ + "static/media/education.ae17f1e6.webp";